import http from "../utils/http";

const postingFields = {
  "fields[0]": "id",
  "fields[1]": "documentId",
  "fields[2]": "posting_number",
  "fields[3]": "market",
  "fields[4]": "state",
  "fields[5]": "in_process_at",
  "fields[6]": "shipment_date",
  "fields[7]": "kiz_status",
  "fields[8]": "return_status",
  "fields[9]": "withdrawal_status",
  "fields[10]": "wbOrderId",
  "fields[11]": "kiz_sent",
};

const itemPopulate = {
  "populate[posting_items][fields][0]": "withdrawal_status",
  "populate[posting_items][fields][1]": "kiz_code",
  "populate[posting_items][fields][2]": "sku",
  "populate[posting_items][fields][3]": "offer_id",
  "populate[posting_items][fields][4]": "name",
  "populate[posting_items][fields][5]": "quantity",
  "populate[posting_items][fields][6]": "price",
  "populate[posting_items][fields][7]": "documentId",
  "populate[posting_items][fields][8]": "kiz_additional_codes",
};

const sortByDate = (a, b) => {
  const aDate = a.in_process_at ? new Date(a.in_process_at).getTime() : 0;
  const bDate = b.in_process_at ? new Date(b.in_process_at).getTime() : 0;
  return bDate - aDate;
};

function buildParams({ market, page, pageSize }) {
  return {
    ...postingFields,
    ...itemPopulate,
    "filters[state][$eq]": "delivered",
    "filters[$and][0][posting_items][withdrawal_status][$ne]": "sold",
    "filters[$and][1][posting_items][kiz_code][$notNull]": true,
    "filters[$and][2][posting_items][kiz_code][$ne]": "",
    ...(market ? { "filters[market][$eq]": market } : {}),
    "pagination[page]": page,
    "pagination[pageSize]": pageSize,
    "sort[0]": "in_process_at:desc",
  };
}

function extractItems(raw) {
  const attr = raw.attributes || {};
  const directItems = raw.posting_items || attr.posting_items;

  if (Array.isArray(directItems)) return directItems;

  const relationItems = directItems?.data;
  if (Array.isArray(relationItems)) {
    return relationItems.map((it) => ({ id: it.id, ...(it.attributes || {}), ...it }));
  }

  return [];
}

function mapWithdrawalRow(raw) {
  const attr = raw.attributes || {};
  const items = extractItems(raw);
  const firstItem = items[0] || {};
  const kiz_codes = items
    .flatMap((item) => [
      item.kiz_code,
      ...(Array.isArray(item.kiz_additional_codes)
        ? item.kiz_additional_codes
        : []),
    ])
    .filter((code) => typeof code === "string" && code.trim() !== "");

  return {
    id: raw.id,
    documentId: raw.documentId || attr.documentId,
    posting_number: raw.posting_number || attr.posting_number,
    market: raw.market || attr.market,
    state: raw.state || attr.state,
    in_process_at: raw.in_process_at || attr.in_process_at,
    shipment_date: raw.shipment_date || attr.shipment_date,
    kiz_status: raw.kiz_status || attr.kiz_status,
    return_status: raw.return_status || attr.return_status,
    withdrawal_status: raw.withdrawal_status || attr.withdrawal_status || firstItem.withdrawal_status,
    wbOrderId: raw.wbOrderId || attr.wbOrderId,
    kiz_sent: raw.kiz_sent ?? attr.kiz_sent,
    items,
    kiz_codes,
    sku: raw.sku || attr.sku || firstItem.sku,
    offer_id: raw.offer_id || attr.offer_id || firstItem.offer_id,
    name: raw.name || attr.name || firstItem.name,
    quantity: raw.quantity || attr.quantity || firstItem.quantity,
    kiz_code: raw.kiz_code || attr.kiz_code || firstItem.kiz_code,
  };
}

export async function fetchWithdrawalPage({ market, page, pageSize }) {
  const { data } = await http.get("/postings", { params: buildParams({ market, page, pageSize }) });
  const rows = (data?.data || []).map(mapWithdrawalRow).sort(sortByDate);
  const total = data?.meta?.pagination?.total ?? rows.length;
  return { rows, total };
}

export async function fetchAllWithdrawal({ market, pageSize = 200 }) {
  const allRows = [];
  let page = 1;
  let total = null;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { rows, total: pageTotal } = await fetchWithdrawalPage({ market, page, pageSize });
    allRows.push(...rows);
    total = pageTotal ?? total ?? 0;

    if (allRows.length >= total || rows.length === 0) {
      break;
    }

    page += 1;
  }

  return allRows;
}
